<template>
  <div class="row">
    <div class="col-6" v-if="puzzle">
      <a :href="puzzle.embedUrl" target="_blank" class="btn btn-sandpiper btn-block open-puzzle-btn"
         :class="questTypeClass(questType)">
        Puzzel bekijken
      </a>
    </div>
  </div>
</template>

<script>
import QuestTypeHelper from "@/mixins/QuestTypeHelper";

export default {
  name: "QuestPuzzleDetails",
  mixins: [ QuestTypeHelper ],
  props: {
    puzzle: Object,
    questType: String
  }
}
</script>

<style lang="scss" scoped>
.open-puzzle-btn
{
  height: auto;
}
</style>